import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { QueryBuilder, QueryService } from '../@tools/query';


@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: [ './main.component.scss' ]
})
export class MainComponent implements OnInit {

    table = '';
    data;
    pages;
    current;
    full;
    primaryKey;

    tabs = [ 'Обзор', 'Создать', 'Поиск' ];
    tab: number = 0;

    perPage = 25;

    qb: QueryBuilder;


    constructor(private route: ActivatedRoute, private router: Router, private query: QueryService, private DATA: DataService) {
        this.table = route.snapshot.params.table;
        if (this.table) {

            this.tab = 0;
            DATA.current_table = this.table;
            query.primaryKey(this.table).then(response => {
                this.primaryKey = response;
            });
            query.full(this.table).then(response => {
                this.full = response;
            });

            this.qb = new QueryBuilder(this.table);
            DATA.applyWith(this.table, this.qb);
            this.qb.per_page(localStorage['perPage'] || 25);

            if (this.table === 'interest') {
                this.qb.per_page(99999);
            }

            query.get(this.qb).then(response => {
                this.data = response['data'];
                DATA.applyModels(this.table, this.data);
                this.pages = response['last_page'];
                this.current = response['current_page'];
            });
        }

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                this.router.navigated = false;
                window.scrollTo(0, 0);
            }
        });

        this.perPage = localStorage['perPage'] || 25;
    }

    ngOnInit() {
    }

    changed(page) {
        this.current = page;

        // let qb = new QueryBuilder(this.table);
        // this.DATA.applyWith(this.table, qb);
        this.qb.per_page(localStorage['perPage'] || 25);

        this.query.get(this.qb.page(page)).then(response => {
            this.data = response['data'];
            this.DATA.applyModels(this.table, this.data);
            this.pages = response['last_page'];
            this.current = response['current_page'];
        });
    }

    onSearch(data) {
        if (this.table) {
            this.current = 1;
            let keys = Object.keys(data);

            this.qb = new QueryBuilder(this.table);
            for (let i in keys) {
                this.qb.where(keys[i], 'like', '%' + data[keys[i]] + '%');
            }
            this.DATA.applyWith(this.table, this.qb);

            this.query.get(this.qb).then(response => {
                this.data = response['data'];
                this.DATA.applyModels(this.table, this.data);
                this.pages = response['last_page'];
                this.current = response['current_page'];
            });
        }
    }

    perPageChanged(value) {
        localStorage['perPage'] = value;
        this.changed(1);
    }
}
